import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { Subject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DepositLimit } from '@core/models/deposit-limit.model';
import { TwoStepDepositDataService } from '@views/modules/member/services/two-step-deposit-data.service';
import { AesService } from '@core/services/aes.service';

@Injectable({
  providedIn: 'root'
})
export class PortalDepositHttpService {

  messages$ = new Subject<any[]>();
  isSuccess: boolean;

  constructor(
    private http: HttpClient,
    private twoStepDepositDataService: TwoStepDepositDataService,
    private aesService: AesService,
  ) {}

  add(memberBankAccount: any) {
    if( memberBankAccount.card_number ) {
      memberBankAccount.card_number = this.aesService.encryptWithReqSignKey(memberBankAccount.card_number);
    }
    
    return this.http.post<ApiResponse>(`/deposit`, memberBankAccount).pipe(
      tap(res => {
        this.isSuccess = res.success;

        const twoStepPGs = this.twoStepDepositDataService.getTwoStepDepositPGs();

        // skip showing success message for two step PGs
        if (this.isSuccess && twoStepPGs.includes(memberBankAccount.payment_gateway_code)) {
          return;
        }

        this.messages$.next(res.message);
      }),
      map(res => res)
    );
  }

  getLimit(pageParam: string): Observable<DepositLimit>{
    return this.http.get<ApiResponse>(`/deposit/limit${pageParam}`).pipe(
      map(res => res.data.rows)
    );
  }
  
  getCryptoInfo(pageParam: any) {
    return this.http.get<ApiResponse>(`/deposit/crypto${pageParam}`).pipe(
      map(res => res)
    );
  }

  cancelDeposit(depositId: number) {
    return this.http.put<ApiResponse>(`/deposit/reject/${depositId}`, {}).pipe(
      map(res => res)
    );
  }

  changeDepositToExpired(depositId: number) {
    return this.http.put<ApiResponse>(`/deposit/expired/${depositId}`, {}).pipe(
      map(res => res)
    );
  }

  addAudBankTransfer(memberBankAccount: any) {
    return this.http.post<ApiResponse>(`/deposit/depositaudbanktransfer`, memberBankAccount).pipe(
      tap(res => {
        this.isSuccess = res.success;
        // skip showing success message for two step PGs
        if (this.isSuccess) {
          return;
        }
      }),
      map(res => res.data.rows)
    );
  }

  cancelAudBankTransferDeposit(depositId: number) {
    return this.http.put<ApiResponse>(`/deposit/cancelpendingpayments/${depositId}`, {}).pipe(
      map(res => res)
    );
  }

  getPendingPaymentAudBankTransferDeposit() {
    return this.http.get<ApiResponse>(`/deposit/getpendingpayments`, {}).pipe(
      map(res => res)
    );
  }

  updatedepositaudbanktransfer(depositId: number, data: any) {
    return this.http.put<ApiResponse>(`/deposit/depositaudbanktransfer/${depositId}`, data).pipe(
      map(res => res)
    );
  }

  changePendingPaymentsDepositToExpired(depositId: number) {
    return this.http.put<ApiResponse>(`/deposit/expiredpendingpayments/${depositId}`, {}).pipe(
      map(res => res)
    );
  }
}
